import { AbstractControl, ValidationErrors } from "@angular/forms";
import { isJSON } from "../util";

export function isJsonValidator(control: AbstractControl): ValidationErrors | null {
    const isJsonValue = isJSON(control.value);
    return isJsonValue ? null : {isNotJson: {value: control.value}};
}
